// =============================================================================
//          (c) Copyright 2021 by Brinks Home Security | Dallas, TX, USA
// =============================================================================
// Version   : 0.1.1
// Created at: 08.30.16
// Project   : Brinks Home Security Shared Assets
// -----------------------------------------------------------------------------
// JS extensions and helpers for Bootstrap's Tooltips component
// -----------------------------------------------------------------------------

import isMobile from 'ismobilejs'

const Tooltip = (($) => {
  const SELECTOR = '[data-toggle="tooltip"]'

  const Event = {
    SHOWN: 'shown.bs.tooltip',
    HIDE: 'hide.bs.tooltip'
  }

  /* --------------------------------------------------------------------------
    Private
  -------------------------------------------------------------------------- */

  // Fixes an open issue with bootstrap 4 and iOS where tooltips cant
  // be dismissed by tapping outside.
  // -> https://github.com/twbs/bootstrap/issues/16028
  function fixIOSTapToDismiss () {
    // It's a truly iOS-specific bug, so browser/device detection, while
    // generally frowned upon, makes sense in this case.
    if (isMobile.apple.device) {
      $(SELECTOR).on(Event.SHOWN, () => {
        // isolate the fix to only when a tooltip is shown
        $('body').css('cursor', 'pointer')
      })

      // Return cursor to default value when tooltip hidden.
      // - Use 'hide' event (as opposed to 'hidden') to ensure it fires before
      //   'shown' event for any other tooltips that are opened.
      $(SELECTOR).on(Event.HIDE, () => {
        $('body').css('cursor', 'auto')
      })
    }
  }

  /* --------------------------------------------------------------------------
    Public
  -------------------------------------------------------------------------- */

  let Tooltip = {
    init () {
      for (let tooltip of $(SELECTOR)) {
        $(tooltip).tooltip()
      }

      fixIOSTapToDismiss()
    }
  }

  return Tooltip
})(jQuery)

export default Tooltip
